<script>
    import VentaInfo from './venta-info.svelte'
    import VentaFicha from './venta-ficha.svelte'
    import VentaPlan from './venta-plan.svelte'
    import VentaComi from './venta-comi.svelte'

    import {API,http_headers,acListCheck, getLoggedUser} from '../global.js'
    import Swal from 'sweetalert2'
    import { createEventDispatcher } from 'svelte';

    export let data = {}

    const dispatch = createEventDispatcher();


    const estados = [
        { TRAMITE : ['PENDIENTE','OK','CANCELADA'] },
        { CANCELADA : [] },
        { PE_APROB : [ 'PENDIENTE','RECH'] }, //solo disponible para usuario autorizador
        { PENDIENTE : ['OK','RECH'] },
        { RECH : [] },
        { OK : ['FINALIZADA']} // solo usuario liquidacion
    ]

    let loading=false
    let formdata = JSON.parse(JSON.stringify(data))
    //console.log(formdata)
    let domidata = data.domisocio ? JSON.parse(JSON.stringify(data.domisocio)) : {}

    if(!formdata.form.planpagos?.importeVenta){
        formdata.form.planpagos = {
            moneda : '$AR',
            complejo: '',
            importeVenta: 0.00,
            importeComisionable: 0.00,
            importeAnticipo: 0.00,
            cantCuotasAnticipo: 1,
            importeSaldo: 0.00,
            cantCuotasSaldo: 12,
            cuotasAnticipo : [],
            cuotasSaldo : [],
            vendedor:getLoggedUser()
        }
    }

    if(!formdata.form.comisiones?.status){
        let porcDefault = 3.5
        formdata.form.comisiones = {
            importeComisionable : 0,
            importeComisionable1 : 0,
            importeComisionable2 : 0,
            importeComisionable3 : 0,
            status : '---',
            comiI1v:0.00, comiI1L1: 0.00, comiI1L2:0.00 , comiI1L3:0.00,
            comiI2v:0.00, comiI2L1: 0.00, comiI2L2:0.00 , comiI2L3:0.00,
            comiI3v:0.00, comiI3L1: 0.00, comiI3L2:0.00 , comiI3L3:0.00,
            /*
            vendedor : '',       porcVendedor : porcDefault,
            usuarioLineaVenta1 : '',    porcLineaVenta1 : 0,
            usuarioLineaVenta2 : '',    porcLineaVenta2 : 0,
            usuarioLineaVenta3 : '',    porcLineaVenta3 : 0,
            */
        }
    }

    let vista = 'info'

    async function guardar(){

        if(formdata.form.usuario!==getLoggedUser()){
            Swal.fire({
              icon: 'error',
              title: `Las modificaciones solo puede realizarlas el propietario, ${formdata.form.usuario}.`,
              showConfirmButton: true,
              timer: 6000
            })
            return
        }

        loading=true

        let rs = await fetch(`${API}/cliente-insertar-venta`,{
            method:'POST',
            headers: http_headers,
            body: JSON.stringify(formdata.form)
        })

        let ds = await rs.json()

        Swal.fire({
          icon: 'success',
          title: 'Venta ingresado.',
          showConfirmButton: false,
          timer: 1000
        })

        dispatch('close')
        loading = false
        //console.log(formdata.form)
    }

</script>
<div class="card fs-6">

    <div class="card-header">

        <ul class="nav nav-tabs">
            <li class="nav-item" on:click={()=>vista='info'}>
                <a class="nav-link" class:active={vista==='info'} aria-current="page" href={"#"}>Info</a>
            </li>
            <li class="nav-item" on:click={()=>vista='ficha'}>
                <a class="nav-link" class:active={vista==='ficha'} href={"#"}>Ficha Socio</a>
            </li>
            <li class="nav-item" on:click={()=>vista='plan'}>
                <a class="nav-link" class:active={vista==='plan'} href={"#"}>Plan Pago</a>
            </li>
            <!--
            <li class="nav-item" on:click={()=>vista='liq'}>
                <a class="nav-link" class:active={vista==='liq'} href={"#"}>Comisiones</a>
            </li>
            <li class="nav-item" on:click={()=>vista='cte'}>
                <a class="nav-link" class:active={vista==='cte'} href={"#"}>Comprobantes</a>
            </li>
            -->
        </ul>
    </div>

    <div class="card-body" style="height: 58vh;overflow:auto;">

        {#if vista==='info'}
            <VentaInfo data={formdata.form} />
        {/if}

        {#if vista==='ficha'}
        <VentaFicha data={formdata} />
        {/if}

        {#if vista==='plan'}
        <VentaPlan data={formdata.form.planpagos} />
        {/if}

        {#if vista==='liq'}
        <VentaComi data={formdata.form} />
        {/if}


    </div>

    <div class="card-footer d-flex justify-content-around">

        <button class="btn btn-light text-danger" on:click={()=>dispatch('close')}>Cancelar</button>
        <button class="btn btn-primary" on:click="{guardar}"
                disabled={formdata.form.estado!=='TRAMITE' && formdata.form.estado!=='PE_APROB'}>Guardar Cambios</button>
    </div>

</div>


    <!--
        id
        idcliente
        usuario
        tipo
        fichasocio
        *planpagos
        debeaprobar
        fecha
        estado
        observ
        *fechaliq
        *idtrx
        *registro
        *rtf
    -->
